import React from "react";
import { InputField } from "../../../../primary/InputField/InputField";
import { SelectField } from "../../../../primary/SelectField/SelectField";
import { PictureIcon } from "../../../../secondary";
import { checkSessionTime, checkSessionType } from "../../../../../utils";
import { SESSION_TIMEOUT_OPTIONS, BROWSE_LBL } from "../../../../../constants";
import formStyle from "../../../../common/ConfigForm/ConfigForm.module.scss";
import styles from "../BasicInfo.module.scss";

export const BasicInfoStatusHeader = ({
  editable,
  customerData,
  header,
  errors,
  register,
  onToggleStatus,
  onSessionTimeoutChange,
  onSessionTimeoutTypeChange,
  previewImg,
  setPreviewImg,
  buttonState,
  setButtonState,
}) => (
  <div className={`${formStyle.form_section_header} ${styles.status_bar}`}>
    <div className={styles.status_group}>
      {editable && customerData?.customerNumber && (
        <>
          <span className={styles.customer_number}>{customerData.customerNumber}</span>
          <span className={styles.divider}></span>
        </>
      )}

      <span className={styles.status_title}>Status:</span>
      {editable ? (
        <label className={styles.toggle}>
          <input
            type="checkbox"
            name="isStatus"
            id="isStatus"
            data-testid="toggleSwitch"
            checked={header.customerStatus === 1}
            onChange={onToggleStatus}
          />
          <span className={styles.toggle_slider}></span>
        </label>
      ) : (
        <span className={styles.status_value}>{header.customerStatus === 1 ? "Active" : "Inactive"}</span>
      )}
    </div>

    <div className={styles.status_group}>
      <span className={styles.status_title}>Session Timeout:{editable && <span className={styles.astrick}>&#42;</span>}</span>
      {editable ? (
        <div className={styles.session_fields}>
          <InputField
            id="sessionTimeOut"
            name="sessionTimeOut"
            defaultValue={header.sessionTimeout}
            dataTestId="sessionTimeOut"
            className={styles.session_input}
            inputRef={register(checkSessionTime)}
            error={errors?.sessionTimeOut?.message}
            onChange={(e) => onSessionTimeoutChange(e.target.value)}
          />
          <SelectField
            id="sessionTimeoutType"
            name="sessionTimeoutType"
            options={SESSION_TIMEOUT_OPTIONS}
            defaultValue={header.sessionTimeoutType}
            className={styles.session_select}
            inputRef={register(checkSessionType)}
            error={errors?.sessionTimeoutType?.message}
            onChange={(e) => onSessionTimeoutTypeChange(e.target.value)}
          />
        </div>
      ) : (
        <span className={styles.status_value}>
          {header.sessionTimeout} {header.sessionTimeoutType}
        </span>
      )}
    </div>

    <div className={styles.status_group}>
      <span className={styles.status_title}>Logo:</span>
      {editable ? (
        <PictureIcon
          previewImg={previewImg}
          setPreviewImg={setPreviewImg}
          buttonState={buttonState}
          setButtonState={setButtonState}
          validator={register}
          id="companyLogo"
          name="companyLogo"
          browseLbl={BROWSE_LBL}
        />
      ) : header.companyLogo ? (
        <img src={header.companyLogo} alt="Company logo" className={styles.logo_preview} />
      ) : (
        <span className={styles.status_value}>-</span>
      )}
    </div>
  </div>
);
